import R from 'ramda';
import _ from 'lodash';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {
  Alert,
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
  ButtonToolbar,
  ToggleButtonGroup,
  ToggleButton,
} from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import sanitize from 'sanitize-filename';
import moment from 'moment';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import NavButtons from '../NavButtons';
import AgreementTextWorkForHire from '../Agreements/AgreementTextWorkForHire';
import AgreementTextPremiumSplit from '../Agreements/AgreementTextPremiumSplit';
import AgreementTextProducer from '../Agreements/AgreementTextProducer';
import DealContractBlock from '../DealContractBlock';
import InviteOther from './InviteOther';
import InviteMember from './InviteMember';
import Signature from './Signature';
import DealMessage from './Message';
import DealChangeLog from './ChangeLog';
import ShortContentLess from '../DealContractBlock/ShortContentLess';
import { PublishesID, COSYND_PDF_URL } from '../../constants';
import getContent from '../ContractBlock/Contents';
import {
  getWorkTypeNameById,
  getMemberNameByUserId,
  compareJSONObjects,
  floatFormat,
  getMemberByUserId,
  getUserDealChange,
  getSubWorkTypeNameById,
} from '../../utils';

import TermsSummary from './DealEditPages/TermsSummary';
import WorkOwnership from './DealEditPages/WorkOwnership';
import Accepts from './DealEditPages/Accepts';
import Changes from './DealEditPages/Changes';
import ChangeStatus from './DealEditPages/ChangeStatus';
import Splits from './DealEditPages/Splits';
import AttorneyTextIntro from './DealEditPages/AttorneyTextIntro';
import PreviewAgreementText from './DealEditPages/PreviewAgreementText';
import OwnerTextIntro from './DealEditPages/OwnerTextIntro';
import CollaboratorTextIntro from './DealEditPages/CollaboratorTextIntro';
import RedlineRequestText from './DealEditPages/RedlineRequestText';
import ShowIcon from './DealEditPages/ShowIcon';

import getSentenceChanges from './DealEditPages/helpers/getSentenceChanges';
import getOtherRedlined from './DealEditPages/helpers/getOtherRedlined';
import getOtherAcceptedRedlined from './DealEditPages/helpers/getOtherAcceptedRedlined';
import getAttorneyStatus from './DealEditPages/helpers/getAttorneyStatus';
import getDealChangeRequests from './DealEditPages/helpers/getDealChangeRequests';
import getState from './DealEditPages/helpers/getState';
import saveBlockChange from './DealEditPages/helpers/saveBlockChange';
import checkIfIsUpdate from './DealEditPages/helpers/checkIfIsUpdate';
import previewIconLogic from './DealEditPages/helpers/previewIconLogic';
import changeRequestLogic from './DealEditPages/helpers/changeRequestLogic';
// TODO: this getOptions should work but something breaks for some reason when
//       you pass the other parameters in.
// import getOptions from './DealEditPages/helpers/getOptions';

const PDFJS = window.PDFJS;

// TODO: kill off all < and > tab things
class DealEdit extends Component {
  tabWidth = 230;
  canvasPDF = null;

  constructor() {
    super();
    this.state = {
      loading: false,
      works: [],
      dealWork: null,
      blocks: [],
      tabs: [],
      tabCount: 0,
      tabIndex: 0,
      tabName: '',
      blockIndex: 0,
      start: 0,
      finalized: false,
      dealOwner: null,
      publishers: [],
      previewIndex: 0,
      showInviteModal: false,
      showInviteMemberModal: false,
      isCollapsPreview: false,
      showSignatureModal: false,
      agreementPreviewMode: 1,
    };
  }

  componentWillMount() {
    this.props.resetDealBlockChanges();
    this.props.loadDealInvites(this.props.params.dealId);
  }

  componentDidMount() {
    if (PDFJS) {
      PDFJS.workerSrc =
        'https://unpkg.com/pdfjs-dist@2.0.99/build/pdf.worker.min.js';
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      deal,
      agreement,
      contractBlocks,
      profile,
      dealUsers,
      statusDealUsers,
      workTypes,
      subWorkTypes,
      members,
      statusUsers,
    } = nextProps;

    let dealWork;

    if (deal) {
      // Load team members
      if (
        members.length === 0 &&
        statusUsers !== actionTypes.MEMBERS_GET_REQUEST
      ) {
        this.props.loadMembers(deal.team);
      }
    }

    if (deal && deal.agreement && deal.agreement_info) {
      if (this.state.works.length === 0) {
        this.setState({ works: deal.agreement_info.works });
      }

      dealWork = deal.work_info;

      if (dealWork && !this.state.dealWork) {
        this.setState({ dealWork });
      }
    }

    if (
      contractBlocks &&
      agreement &&
      dealWork &&
      agreement.id === deal.agreement
    ) {
      if (this.state.tabCount === 0) {
        const wrapper = findDOMNode(this.refs.tabsContainer);
        const blocks = this.filter(
          agreement,
          contractBlocks,
          dealWork,
          workTypes,
          subWorkTypes
        );

        let tabCount = Math.floor((wrapper.clientWidth - 100) / this.tabWidth);
        if (wrapper.clientWidth < 750 && wrapper.clientWidth > 380) {
          tabCount = blocks.length >= 3 ? 3 : blocks.count;
        }

        const tabs = blocks.slice(0, tabCount);

        if (tabCount < blocks.length) {
          tabs.push('>');
        }

        if (members) {
          this.setState(
            { blocks, tabs, tabCount, start: 0, tabName: tabs[0].name },
            () => {
              this.scrollToRef(tabs[0].name);
            }
          );
        }
      } else {
        const blocks = this.filter(
          agreement,
          contractBlocks,
          dealWork,
          workTypes,
          subWorkTypes
        );
        const tabs = [];
        this.state.tabs.forEach((tab) => {
          if (tab === '<' || tab === '>') {
            tabs.push(tab);
          } else {
            const foundTab = R.find(R.propEq('id', tab.id))(blocks);
            if (foundTab) {
              tabs.push(foundTab);
            }
          }
        });

        this.setState({ blocks, tabs });
      }
    }

    if (
      (statusDealUsers === actionTypes.DEAL_USERS_GET_SUCCESS ||
        statusDealUsers === actionTypes.DEAL_USER_UPDATE_SUCCESS) &&
      profile &&
      dealUsers
    ) {
      const dealUser = R.find(R.whereEq({ user: profile.id, type: 'member' }))(
        dealUsers
      );
      const dealOwner = R.find(R.propEq('type', 'owner'))(dealUsers);
      let updated =
        this.props.statusDealUsers !== statusDealUsers &&
        statusDealUsers === actionTypes.DEAL_USER_UPDATE_SUCCESS;

      this.setState(
        {
          dealUser,
          dealOwner,
          userStatus: dealUser && dealUser.status,
          finalized:
            dealOwner &&
            (dealOwner.status === 'Finalized' ||
              dealOwner.status === 'Accepted'),
        },
        () => {
          if (updated) {
            this.checkDealStatus();
          } else {
            this.setState({ loading: false });
          }
        }
      );
    }

    if (
      statusDealUsers !== this.props.statusDealUsers &&
      statusDealUsers === actionTypes.DEAL_USERS_GET_SUCCESS &&
      dealUsers
    ) {
      const dealOwner = R.find(R.propEq('type', 'owner'))(dealUsers);
      const finalized = dealOwner && dealOwner.status === 'Finalized';

      const publishers = [];
      dealUsers.forEach((dealUser) => {
        if (dealUser.type === 'member') {
          if (dealUser.publishers && dealUser.publishers.length) {
            dealUser.publishers.forEach((publish, i) => {
              publishers.push({
                ...publish,
                dealUserId: dealUser.id,
                userId: dealUser.user,
                index: i,
              });
            });
          } else {
            publishers.push({
              dealUserId: dealUser.id,
              userId: dealUser.user,
              index: 0,
              publisher_name: '',
              publisher_share: 0,
              society: '',
            });
          }
        }
      });

      this.setState({ finalized, dealOwner, publishers });
    }
  }

  filter(agreement, contractBlocks, dealWork, workTypes, subWorkTypes) {
    let blocks = R.filter(
      (block) =>
        (agreement.type === 'premium' &&
          block['block_type'].includes('premium') === true) ||
        (agreement.type === 'workforhire' &&
          block['block_type'].includes('work_for_hire') === true) ||
        (agreement.type === 'producer' &&
          block['block_type'].includes('producer') === true),
      contractBlocks
    );

    blocks = R.sortBy(R.prop('last_modified'))(blocks);

    const workTypeName = getWorkTypeNameById(dealWork.type, workTypes);
    const workSubTypeName = getSubWorkTypeNameById(
      dealWork.sub_type,
      subWorkTypes
    );

    if (agreement.type === 'workforhire' || agreement.type === 'producer') {
      return blocks;
    } else if (dealWork && dealWork.additional) {
      if (workTypeName === 'Music' && workSubTypeName !== 'Sound Recording') {
        return [
          { id: 0, name: 'Overview' },
          { id: PublishesID, name: 'Publishers' },
        ];
      }
      return [{ id: 0, name: 'Overview' }];
    } else {
      if (workTypeName === 'Music' && workSubTypeName !== 'Sound Recording') {
        return R.insertAll(
          0,
          [
            { id: 0, name: 'Overview' },
            { id: PublishesID, name: 'Publishers' },
          ],
          blocks
        );
      }
      return R.insertAll(0, [{ id: 0, name: 'Overview' }], blocks);
    }
  }

  checkDealStatus() {
    let { dealUsers, invites, deal, agreement, members } = this.props;
    const { finalized, dealWork } = this.state;

    if (finalized && invites && dealUsers) {
      let accepts = 0;
      invites = R.filter((invite) => invite.type === 'member', invites);
      invites.forEach((invite) => {
        if (invite.invitee) {
          const member = R.find(
            R.whereEq({ user: invite.invitee, type: 'member' })
          )(dealUsers);
          if (member) {
            if (member.status === 'Accepted') {
              accepts++;
            }
          }
        }
      });

      const progress = Math.round((accepts * 100) / invites.length);

      if (deal.progress !== progress && dealWork && !dealWork.date_accepted) {
        this.props.updateDeal(deal.id, { progress });

        if (accepts === invites.length) {
          this.props.alert('success', 'All accepted! Deal completed!');
          this.props.updateWork(deal.work, {
            date_accepted: moment().format('YYYY-MM-DDTHH:mm:ss'),
          });

          dealWork.work_ownership_info.forEach((ownership) => {
            const member = getMemberByUserId(ownership.user, members);
            if (member && member.uesr_info) {
              const user = member.user_info;
              this.props.updateWorkOwnership({
                ...ownership,
                name: user.name,
                address: user.address,
                city: user.city,
                state: user.state,
                postal: user.postal,
                country: user.country,
              });
            }
          });

          if (!agreement.completed) {
            this.props.updateAgreement({ ...agreement, completed: true });
          }
        }
      }
    }
    this.setState({ loading: false });
  }

  scrollToRef = (blockName) => {
    this.refPreview.scrollTo(0, 0);
    this.refAgreementTextPreview.scrollTo(0, 0);
    let offset = 0;

    // Scrolls Terms summary preview
    if (this.state.previewIndex === 0) {
      if (this[`ref${blockName.replace(/\s/g, '')}`]) {
        offset =
          findDOMNode(
            this[`ref${blockName.replace(/\s/g, '')}`]
          ).getBoundingClientRect().top -
          findDOMNode(this.refPreview).getBoundingClientRect().top -
          50;
      }
    }
    this.refPreview.scrollTo(0, offset);

    // Scrolls the Agreement text preview
    if (this.props.agreement.type === 'workforhire') {
      if (this.refAgreementTextHire) {
        if (
          findDOMNode(this.refAgreementTextHire).getElementsByClassName(
            blockName.replace(/\s/g, '')
          )[0]
        ) {
          offset =
            findDOMNode(this.refAgreementTextHire)
              .getElementsByClassName(blockName.replace(/\s/g, ''))[0]
              .getBoundingClientRect().top -
            findDOMNode(this.refAgreementTextPreview).getBoundingClientRect()
              .top -
            100;
        }
      }
    } else if (this.props.agreement.type === 'producer') {
      if (this.refAgreementTextProducer) {
        if (
          findDOMNode(this.refAgreementTextProducer).getElementsByClassName(
            blockName.replace(/\s/g, '')
          )[0]
        ) {
          offset =
            findDOMNode(this.refAgreementTextProducer)
              .getElementsByClassName(blockName.replace(/\s/g, ''))[0]
              .getBoundingClientRect().top -
            findDOMNode(this.refAgreementTextPreview).getBoundingClientRect()
              .top -
            100;
        }
      }
    } else {
      if (this.refAgreementTextPremiumSplit) {
        if (
          findDOMNode(this.refAgreementTextPremiumSplit).getElementsByClassName(
            blockName.replace(/\s/g, '')
          )[0]
        ) {
          offset =
            findDOMNode(this.refAgreementTextPremiumSplit)
              .getElementsByClassName(blockName.replace(/\s/g, ''))[0]
              .getBoundingClientRect().top -
            findDOMNode(this.refAgreementTextPreview).getBoundingClientRect()
              .top -
            100;
        }
      }
    }
    this.refAgreementTextPreview.scrollTo(0, offset);
  };

  handleSelect(index) {
    let { blocks, tabs, tabCount, start } = this.state;

    if (tabs[index] === '>' && index === tabs.length - 1) {
      const newTabs = ['<'].concat(
        blocks.slice(start + tabCount, start + tabCount + tabCount)
      );

      if (start + tabCount + tabCount < blocks.length) {
        newTabs.push('>');
      }

      this.setState(
        {
          tabs: newTabs,
          tabIndex: 1,
          start: start + tabCount,
          tabName: newTabs[1].name,
        },
        () => {
          this.scrollToRef(newTabs[1].name);
        }
      );
    } else if (tabs[index] === '<' && index === 0) {
      const newStart = start - tabCount;
      let newTabs = blocks.slice(newStart, newStart + tabCount);
      let newTabIndex = tabCount - 1;

      if (newStart > 0) {
        newTabs = ['<'].concat(newTabs);
        newTabIndex++;
      }
      newTabs.push('>');

      this.setState(
        {
          tabs: newTabs,
          tabIndex: newTabIndex,
          start: newStart,
          tabName: newTabs[newTabIndex].name,
        },
        () => {
          this.scrollToRef(newTabs[newTabIndex].name);
        }
      );
    } else {
      this.setState({ tabIndex: index, tabName: tabs[index].name }, () => {
        this.scrollToRef(tabs[index].name);
      });
    }
  }

  getBlockIndex(tab) {
    const { blocks } = this.state;
    return R.findIndex(R.propEq('id', tab.id))(blocks);
  }

  getBlockChecked(id) {
    const {
      dealBlocks,
      contractBlocks,
      agreement,
      dealChanges,
      deal,
      profile,
    } = this.props;
    const block = R.find(R.propEq('id', id))(dealBlocks);

    // Check if accept is not matched to owners' change (for tab checkmark)
    const isOwner = deal.user === profile.id;
    const ownerDealChange = getUserDealChange(dealChanges, id, deal.user, true);

    if (block && agreement) {
      const contractBlock = R.find(R.propEq('id', block.id))(contractBlocks);

      if (contractBlock && contractBlock.name === 'Dispute Resolution') {
        // const ownershipBlock = dealBlocks.find(block => block.id === 4);
        // if (ownershipBlock && ownershipBlock.changes && block.accept) {
        //   return false;
        // } else {
        //   return block.accept ? true : block.checked;
        // }
        return block.accept ? true : block.checked;
      }

      if (
        (agreement.type === 'premium' &&
          contractBlock &&
          contractBlock.name === 'Cure; Remedies') ||
        (contractBlock && contractBlock.name === 'Services') ||
        (contractBlock && contractBlock.name === 'Ownership')
      ) {
        if (block.accept === undefined || block.accept2 === undefined) {
          return false;
        } else if (block.accept && block.accept2) {
          if (ownerDealChange && !isOwner) {
            const ownerChange = JSON.parse(ownerDealChange.changes);
            if (!_.has(block, 'changes')) {
              return true;
            }
            if (
              !compareJSONObjects(
                ownerChange.contract_block.changes,
                block.changes
              )
            ) {
              return false;
            }
          }
          return true;
        } else {
          return block.checked;
        }
      }
      if (contractBlock && contractBlock.name === 'Payments') {
        const ownershipContractBlock = R.find(R.propEq('name', 'Ownership'))(
          contractBlocks
        );
        if (
          ownershipContractBlock &&
          ownershipContractBlock.options &&
          ownershipContractBlock.options.composition === 1 &&
          (contractBlock.options.statutoryPercentage === '' ||
            contractBlock.options.statutoryPercentage === undefined)
        ) {
          return false;
        }
      }
      return block.accept ? true : block.checked;
    } else {
      return false;
    }
  }

  // See the getOptions helper function (we can replace this function with it)
  getOptions(id) {
    if (id === PublishesID) {
      return { publishers: this.state.publishers };
    } else {
      const blocks = this.props.agreementContractBlocks || [];
      const index = R.findIndex(R.propEq('contract_block', id))(blocks);

      if (index === -1) {
        return null;
      } else {
        return {
          content: blocks[index].content,
          ...JSON.parse(blocks[index].options),
        };
      }
    }
  }

  handleTab(direction) {
    let { tabIndex } = this.state;

    if (direction === 'back') tabIndex--;
    else tabIndex++;

    this.handleSelect(tabIndex);
    window.scrollTo(0, 0);
  }

  handleUserStatus = (e) => {
    e.preventDefault();
    const { dealUser, userStatus } = this.state;

    if (userStatus !== 'Accepted') {
      if (dealUser) {
        if (e.target.value === 'Accepted') {
          this.setState({ showSignatureModal: true });
        } else {
          const data = {
            ...dealUser,
            status: e.target.value,
          };
          this.props.updateDealUser(data);
        }
      }
    }

    return false;
  };

  handleSign = (signatureUrl) => {
    const { dealUser } = this.state;

    if (dealUser) {
      const data = {
        ...dealUser,
        status: 'Accepted',
        date_accepted: moment().format('YYYY-MM-DDTHH:mm:ss'),
        signature: signatureUrl,
      };

      this.setState({ loading: true });
      this.props.updateDealUser(data);
    }
  };

  handleOwnerDeal() {
    const {
      deal,
      profile,
      dealBlocks,
      contractBlocks,
      agreementContractBlocks,
      agreement,
      dealUsers,
      dealChanges,
      updateWorkOwnership,
      createDealChange,
      updateDealChange,
      deletePublisher,
      updatePublisher,
      createPublisher,
      saveBlockContent,
      updateAgreement,
      notifyDealChange,
    } = this.props;
    const { dealWork } = this.state;
    let allChanged = false;

    dealBlocks.forEach(({ id, changes, content, accept, accept2 }, i) => {
      if ((!accept || !accept2) && changes) {
        if (id === 0) {
          let changed = false;
          if (dealWork && dealWork.work_ownership_info) {
            changes.forEach((change) => {
              const member = R.find(R.propEq('id', change.id))(
                dealWork.work_ownership_info
              );
              if (member) {
                let ownership = { ...member };

                if (change.role_ids) {
                  ownership.role_ids = change.role_ids;
                }
                if (change.ownership_type) {
                  ownership.ownership_type = change.ownership_type;
                }
                if (
                  change.percentage !== undefined &&
                  member.percentage !== change.percentage
                ) {
                  ownership.percentage = floatFormat(change.percentage);
                }

                if (!compareJSONObjects(member, ownership)) {
                  changed = true;
                  updateWorkOwnership(ownership);
                }
              }
            });
          }

          if (changed) {
            allChanged = true;
            const data = {
              deal: deal.id,
              user: profile.id,
              changes: JSON.stringify({ contract_block: dealBlocks[i] }),
              type: 'update-contract-block',
            };
            createDealChange(data);
          }
        } else if (id === PublishesID) {
          if (changes.adjust) {
            let changed = false;
            dealUsers.forEach((dealUser) => {
              if (dealUser.publishers && dealUser.publishers.length) {
                dealUser.publishers.forEach((publisher) => {
                  const index2 = R.findIndex(R.propEq('id', publisher.id))(
                    changes.publishers
                  );
                  if (index2 === -1) {
                    changed = true;
                    deletePublisher(publisher);
                  } else {
                    // eslint-disable-next-line
                    const { dealUserId, userId, index, ...changedPublisher } =
                      changes.publishers[index2];
                    if (!compareJSONObjects(changedPublisher, publisher)) {
                      changed = true;
                      updatePublisher(changedPublisher);
                    }
                  }
                });
              }
            });
            changes.publishers.forEach((publisher) => {
              if (
                !publisher.id &&
                (publisher.publisher_name ||
                  publisher.publisher_share ||
                  publisher.society)
              ) {
                changed = true;
                createPublisher({
                  ...publisher,
                  deal: deal.id,
                  user: publisher.userId,
                });
              }
            });

            if (changed) {
              allChanged = true;
              const data = {
                deal: deal.id,
                user: profile.id,
                changes: JSON.stringify({
                  contract_block: { id: PublishesID, changes },
                }),
                type: 'update-contract-block',
              };
              this.props.createDealChange(data);
            }
          }
        } else {
          let block = R.find(R.propEq('contract_block', id))(
            agreementContractBlocks
          );
          let changed = false;

          if (block) {
            if (!compareJSONObjects(changes, JSON.parse(block.options))) {
              changed = true;
              block.options = JSON.stringify(changes);
              block.content = content;
              saveBlockContent(block);
            }
          }

          block = R.find(R.propEq('id', id))(contractBlocks);
          if (block && block.name === 'Licensing Permissions') {
            if (
              !compareJSONObjects(agreement.licenser_ids, changes.licenserIds)
            ) {
              changed = true;
              agreement.licenser_ids = changes.licenserIds || [];
              updateAgreement(agreement);
            }
          }

          if (changed) {
            allChanged = true;
            const data = {
              deal: deal.id,
              user: profile.id,
              changes: JSON.stringify({ contract_block: dealBlocks[i] }),
              type: 'update-contract-block',
            };
            createDealChange(data);
          }
        }
      }

      let block = { id, accept: true };
      const contractBlock = R.find(R.propEq('id', block.id))(contractBlocks);

      if (
        (agreement.type === 'premium' &&
          contractBlock &&
          contractBlock.name === 'Cure; Remedies') ||
        (contractBlock && contractBlock.name === 'Services') ||
        (contractBlock && contractBlock.name === 'Ownership')
      ) {
        block.accept2 = true;
      }

      const data = {
        deal: deal.id,
        user: profile.id,
        changes: JSON.stringify({ contract_block: block }),
        type: 'change-request-contract-block',
      };

      saveBlockChange(
        block,
        data,
        dealChanges,
        updateDealChange,
        createDealChange
      );
    });

    if (allChanged) {
      notifyDealChange({
        sender: profile.id,
        user: deal.user,
        deal: deal.id,
        type: 'deal_change',
      });
    }
  }

  updateDealChangeForInvitee = (
    id,
    blockName,
    ownerChange,
    updatedInvitees,
    dealChanges,
    profile,
    dealUsersList
  ) => {
    const dealUsers = dealUsersList.filter(
      (user) => user.type === 'member' && user.user !== profile.id
    );

    dealUsers.forEach((user) => {
      const userDealChange = getUserDealChange(
        dealChanges,
        id,
        user.user,
        false
      );

      if (userDealChange) {
        const userChange = JSON.parse(userDealChange.changes);

        if (
          (userChange.contract_block.accept ||
            userChange.contract_block.accept2) &&
          _.has(userChange.contract_block, 'changes') &&
          userChange.contract_block.changes !== null &&
          !compareJSONObjects(ownerChange, userChange.contract_block.changes)
        ) {
          let isUpdate = checkIfIsUpdate(blockName, userChange, ownerChange);

          if (isUpdate) {
            this.props.updateDealChange({
              ...userDealChange,
              changes: JSON.stringify({
                contract_block: { id: id, changes: null },
              }),
            });

            const findIndex = _.findIndex(
              updatedInvitees,
              (invitee) => invitee.id === user.user
            );
            if (findIndex === -1) {
              updatedInvitees = [
                ...updatedInvitees,
                _.find(this.props.users, (data) => data.id === user.user),
              ];
            }
          }
        }
      }
    });

    return updatedInvitees;
  };

  handleNext() {
    const {
      deal,
      profile,
      dealBlocks,
      dealUsers,
      dealChanges,
      invites,
      hideAlert,
      router,
      sendEmailToInviteeDealChange,
    } = this.props;
    const { blocks, finalized } = this.state;

    let checkedAll = blocks.every(
      ({ id, name }) => this.getBlockChecked(id) === true
    );
    let allChanged = false;

    let uncheckedBlocks = [];
    blocks.forEach(({ id, name }) => {
      if (this.getBlockChecked(id) === false) {
        uncheckedBlocks = [...uncheckedBlocks, name];
      }
    });

    hideAlert();

    const isAttorney = getAttorneyStatus(profile, invites);
    if (finalized || isAttorney) {
      router.replace('/');
      return false;
    }

    if (deal) {
      if (checkedAll) {
        if (deal.user === profile.id) {
          // isOwner
          this.handleOwnerDeal();

          let updatedInvitees = [];
          blocks.forEach(({ id, name }) => {
            let block = R.find(R.propEq('id', id))(dealBlocks);
            if (block.changes) {
              updatedInvitees = this.updateDealChangeForInvitee(
                id,
                name,
                block.changes,
                updatedInvitees,
                dealChanges,
                profile,
                dealUsers
              );
            }
          });
          const emailData = {
            invitees: updatedInvitees,
            owner: profile,
            deal: deal,
          };
          sendEmailToInviteeDealChange(emailData);
        } else {
          blocks.forEach(({ id, options, name }) => {
            let block = R.find(R.propEq('id', id))(dealBlocks);
            if (name === 'Overview') {
              const agreementWorks = deal.agreement_info.works;
              const work = agreementWorks.find(
                (work) => work.user === deal.user
              );

              const originalOwnership =
                work &&
                work.work_ownership_info.map((info) => {
                  return {
                    role_ids: info.role_ids,
                    ownership_type: info.ownership_type,
                    percentage: parseInt(info.percentage, 10),
                    id: info.id,
                  };
                });

              if (!block.changes) {
                block = {
                  ...block,
                  changes: originalOwnership,
                };
              }
            } else {
              if (!block.changes) {
                block = {
                  ...block,
                  changes: options,
                };
              }
            }

            if (block) {
              if (id === PublishesID) {
                const dealUser = R.find(R.propEq('user', profile.id))(
                  dealUsers
                );

                if (block.changes) {
                  let publishers = R.filter(
                    (publisher) => publisher.userId === profile.id,
                    block.changes.publishers
                  );

                  if (block.changes.adjust) {
                    const publishersInfo = publishers.map(
                      ({ index, dealUserId, userId, ...publisher }) => publisher
                    );
                    if (
                      !compareJSONObjects(dealUser.publishers, publishersInfo)
                    ) {
                      block = {
                        ...block,
                        changes: {
                          publishers,
                          adjust: true,
                          removes: block.changes.removes,
                        },
                        checked: true,
                      };
                    }
                  }
                } else {
                  const publishers = dealUser.publishers.map((item) => {
                    return {
                      publisher_name: item.publisher_name,
                      publisher_share: parseInt(item.publisher_share, 10),
                      society: item.society,
                      userId: item.user,
                    };
                  });
                  block = {
                    ...block,
                    changes: { publishers, adjust: false, removes: [] },
                    checked: true,
                  };
                }
              }

              const data = {
                deal: deal.id,
                user: profile.id,
                changes: JSON.stringify({ contract_block: block }),
                type: 'change-request-contract-block',
              };

              if (
                saveBlockChange(
                  block,
                  data,
                  this.props.dealChanges,
                  this.props.updateDealChange,
                  this.props.createDealChange
                )
              ) {
                allChanged = true;
              }
            }
          });

          if (allChanged) {
            this.props.notifyDealChange({
              sender: profile.id,
              user: deal.user,
              deal: deal.id,
              type: 'deal_change',
            });
          }
        }

        if (!this.state.loading) {
          this.props.router.push('/agreements');
        }
      } else {
        // Check percent sum in the Overview
        if (uncheckedBlocks.includes('Overview')) {
          const block = blocks.find((item) => item.name === 'Overview');
          const dealBlock = dealBlocks.find((item) => item.id === block.id);

          if (dealBlock) {
            if (dealBlock.changes) {
              let totalPercent = 0;
              dealBlock.changes.forEach(
                (change) => (totalPercent += change.percentage)
              );

              if (totalPercent !== 100) {
                this.props.alert(
                  'error',
                  'Oops! Please make sure the ownership splits should be 100% as sum.'
                );

                return false;
              }
            }
          }
        }

        this.props.alert(
          'error',
          `Oops! You did not fully answer a question. Please recheck the "${uncheckedBlocks.join(
            ', '
          )}" ${
            uncheckedBlocks.length > 1 ? 'tabs' : 'tab'
          } to see what was missed.`
        );
      }
    } else {
      return false;
    }
  }

  handlePreviewItem = (e, index) => {
    e.preventDefault();

    if (index === 1) {
      window.scrollTo(0, document.body.scrollHeight - 950);
    } else if (index === 2) {
      // Show invite modal for attorney
      this.setState({ showInviteModal: true });
    } else if (index === 6) {
      // Show invite modal for member
      this.setState({ showInviteMemberModal: true });
    } else {
      this.setState({ previewIndex: index }, () => {
        this.scrollToRef(this.state.tabName);
      });
    }
  };

  handleAgreementDownload = (e) => {
    e.preventDefault();
    const { agreement } = this.props;

    if (agreement) {
      // Get agreement content
      findDOMNode(this.refs.printContainer).innerHTML = findDOMNode(
        this.refs.agreementTerms
      ).innerHTML;
      const notVisibles = document.querySelectorAll(
        '.pdf-wrapper .work-not-accepted, .pdf-wrapper .redline, .pdf-wrapper .hover-box'
      );

      if (notVisibles) {
        Array.prototype.forEach.call(notVisibles, function (node) {
          node.parentNode.removeChild(node);
        });
      }

      // Get Agreement text contents
      var agreementText = findDOMNode(this.refs.printContainer).innerHTML;

      // Sanitize filename string
      var agreementFilename =
        sanitize(agreement.name)
          .toLowerCase()
          .replace('.', '_')
          .replace('(', '_')
          .replace(')', '_')
          .split(' ')
          .join('_') + '.pdf';

      // Populate form fields
      findDOMNode(this.refs.agreementFilename).value = agreementFilename;
      findDOMNode(this.refs.agreementTextContents).value = agreementText;

      // Submit form
      findDOMNode(this.refs.agreementToPDF).action = COSYND_PDF_URL;
      findDOMNode(this.refs.agreementToPDF).submit();

      // findDOMNode(this.refs.agreementToPDF).action = '';
      findDOMNode(this.refs.printContainer).innerHTML = '';
    }

    return false;
  };

  handleFinalize = (e) => {
    e.preventDefault();

    const { dealOwner } = this.state;
    const { blocks } = this.state;
    let checkedAll = blocks.every(
      ({ id, name }) => this.getBlockChecked(id) === true
    );

    if (dealOwner && checkedAll) {
      this.handleOwnerDeal();
      const data = {
        ...dealOwner,
        status: 'Finalized',
      };
      this.setState({ loading: true });
      this.props.updateDealUser(data);
    } else {
      this.props.alert('error', 'Please fully answer a question');
    }
  };

  renderFinalize() {
    const { profile, members, dealUsers, deal, invites } = this.props;
    const {
      dealOwner,
      finalized,
      loading,
      dealUser,
      userStatus,
      showSignatureModal,
    } = this.state;

    let ownerName = 'Originating User';
    let isOwner = false;

    if (dealOwner) {
      ownerName = getMemberNameByUserId(dealOwner.user, members);
      isOwner = profile.id === dealOwner.user;
    }

    return (
      <div ref={(c) => (this.refDealStatus = c)}>
        <div>
          <br />
          <hr />
          <div className="subheading">Deal Status</div>
        </div>

        {finalized ? (
          <div className="ready-to-sign">
            <ChangeStatus
              dealUsers={dealUsers}
              deal={deal}
              invites={invites}
              finalized={finalized}
              dealUser={dealUser}
              userStatus={userStatus}
              handleUserStatus={this.handleUserStatus}
            />
          </div>
        ) : (
          <div className="need-finalize">
            <Alert bsStyle="warning">
              <strong>Waiting</strong>&nbsp;to be finalized by&nbsp;
              <strong>{isOwner ? 'You' : ownerName}</strong>
            </Alert>

            <p>To save all changes, click on “Save and Exit” below.</p>

            {isOwner ? (
              <div>
                <p>
                  If there are no further changes/edits to be made, please
                  review your agreement carefully and click on Finalize Now to
                  allow everyone to sign. The agreement cannot be changed after
                  this is done.
                </p>
                <div className="finalize-button-view">
                  <button onClick={this.handleFinalize} disabled={loading}>
                    {loading && (
                      <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                    )}
                    Finalize Now
                  </button>
                  <button onClick={() => this.handleNext()}>
                    Save and Exit
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <p>
                  If there are no further changes, the collaborator that created
                  this agreement will need to finalize this agreement. Once they
                  have, you will be able to sign it by choosing "Sign" as your
                  status.
                </p>
                <button onClick={() => this.handleNext()}>Save and Exit</button>
              </div>
            )}
          </div>
        )}

        <Signature
          show={showSignatureModal}
          onClose={() => {
            this.setState({ showSignatureModal: false });
          }}
          onSign={this.handleSign}
        />
      </div>
    );
  }

  renderChangeStatus() {
    const { dealUsers, deal, invites } = this.props;
    const { finalized, dealUser, userStatus } = this.state;

    if (deal && dealUsers && invites) {
      return (
        <div className="user-status">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {invites.map((invite, i) => {
                if (invite.type === 'member' && deal.id === invite.deal) {
                  let member = null;
                  if (invite.invitee) {
                    member = R.find(
                      R.whereEq({ user: invite.invitee, type: 'member' })
                    )(dealUsers);
                  }

                  return member ? (
                    <tr key={i}>
                      <td>{invite.name}</td>
                      <td>
                        {finalized && dealUser && dealUser.id === member.id ? (
                          <select
                            value={userStatus}
                            onChange={this.handleUserStatus}
                          >
                            <option value="">Status update</option>
                            <option value="Reviewing">Reviewing</option>
                            <option value="Accepted">
                              {userStatus === 'Accepted' ? 'Signed' : 'Sign'}
                            </option>
                          </select>
                        ) : member ? (
                          member.status === 'Accepted' ? (
                            'Signed'
                          ) : (
                            member.status || 'Reviewing'
                          )
                        ) : (
                          'Reviewing'
                        )}
                      </td>
                      <td>
                        {member &&
                        member.status === 'Accepted' &&
                        member.date_accepted
                          ? moment(member.date_accepted).format('MM/DD/YYYY')
                          : ''}
                      </td>
                    </tr>
                  ) : (
                    <tr key={i}>
                      <td>{invite.name}</td>
                      <td>Inviting</td>
                      <td>&nbsp;</td>
                    </tr>
                  );
                } else {
                  return null;
                }
              })}
            </tbody>
          </table>
        </div>
      );
    }
  }

  renderContractBlocks() {
    const { blocks, tabName, dealOwner } = this.state;
    const {
      agreement,
      agreementContractBlocks,
      dealBlocks,
      profile,
      members,
      contractBlocks,
    } = this.props;

    let isOwner = false;

    if (dealOwner) {
      isOwner = profile.id === dealOwner.user;
    }

    if (
      agreement &&
      agreement.type !== 'split' &&
      blocks.length &&
      agreementContractBlocks &&
      members
    ) {
      return blocks.map((block, i) => {
        if (block.name !== 'Licensing Permissions') {
          const index = R.findIndex(R.propEq('contract_block', block.id))(
            agreementContractBlocks
          );
          if (index !== -1) {
            const changeBlock = _.find(
              dealBlocks,
              (item) => item.id === block.id
            );

            if (changeBlock && changeBlock.changes && isOwner) {
              const blockContent = getContent(block.name, changeBlock.changes, {
                type: agreement.type,
                state: getState(
                  isOwner,
                  contractBlocks,
                  agreementContractBlocks,
                  dealBlocks
                ),
              });
              block.content = blockContent.content;
              block.options = changeBlock.changes;
            } else {
              block.content = agreementContractBlocks[index].content;
              block.options = JSON.parse(
                agreementContractBlocks[index].options
              );
            }

            if (!isOwner) {
              block.options = JSON.parse(
                agreementContractBlocks[index].options
              );
            }

            if (
              block.name === 'Services' ||
              block.name === 'Ownership' ||
              block.name === 'Cure; Remedies'
            ) {
              return (
                <div key={i}>
                  <ShortContentLess
                    ref={(c) =>
                      (this[`ref${block.name.replace(/\s/g, '')}`] = c)
                    }
                    block={block}
                    tabName={tabName}
                    blocks={blocks}
                    type={0}
                    children={this.renderChangeRequests(block, 1)}
                    children1={this.renderChangeRequests(block, 2)}
                  />
                </div>
              );
            } else {
              return (
                <div key={i}>
                  <ShortContentLess
                    ref={(c) =>
                      (this[`ref${block.name.replace(/\s/g, '')}`] = c)
                    }
                    block={block}
                    tabName={tabName}
                    blocks={blocks}
                  >
                    {this.renderChangeRequests(block, 1)}
                  </ShortContentLess>
                </div>
              );
            }
          }
        }
        return null;
      });
    }
  }

  renderWorks() {
    const {
      agreement,
      contractBlocks,
      members,
      dealBlocks,
      deal: dealOrigin,
      dealUsers: dealUsersOrigin,
      profile,
      ownershipTypes,
    } = this.props;
    const { works, dealOwner } = this.state;
    let workTypeName = '';

    if (works && works.length) {
      const work = _.find(works, (work) => work.id === this.props.deal.work);
      let withPublishers = false;
      if (work.type) {
        workTypeName = getWorkTypeNameById(work.type, this.props.workTypes);
        withPublishers = workTypeName === 'Music';
      }

      return (
        <WorkOwnership
          work={work}
          withPublishers={withPublishers}
          agreement={agreement}
          contractBlocks={contractBlocks}
          members={members}
          dealBlocks={dealBlocks}
          dealOrigin={dealOrigin}
          dealUsersOrigin={dealUsersOrigin}
          profile={profile}
          ownershipTypes={ownershipTypes}
          dealOwner={dealOwner}
        />
      );
    }
  }

  getAcceptChangeStatus(block) {
    const { changeRequests, accepts, changeRequests2, accepts2 } =
      getDealChangeRequests(
        block,
        this.props.dealChanges,
        this.props.members,
        this.props.deal,
        this.props.agreement,
        this.props.dealUsers
      );
    return (
      changeRequests.length > 0 ||
      accepts.length > 0 ||
      changeRequests2.length > 0 ||
      accepts2.length > 0
    );
  }

  renderTermsSummary() {
    const { agreement, dealChanges, profile, dealBlocks } = this.props;
    const { tabName, blocks, finalized, dealWork } = this.state;

    const blockSelected =
      tabName === 'Overview' ||
      tabName === 'Publishers' ||
      tabName === 'Licensing Permissions';
    const ownershipBlocks = _.filter(
      blocks,
      (block) =>
        block.name === 'Overview' ||
        block.name === 'Publishers' ||
        block.name === 'Licensing Permissions'
    );
    const overviewBlock = _.find(blocks, (block) => block.name === 'Overview');
    const hasOtherRedline = getOtherRedlined(blocks, dealChanges);
    const hasOtherAcceptedRedline = getOtherAcceptedRedlined(blocks, agreement);

    if (!agreement) {
      return null;
    }

    let dealBlock = null;
    if (overviewBlock) {
      dealBlock = R.find(R.propEq('id', overviewBlock.id))(dealBlocks);
    }

    return (
      <TermsSummary>
        {(agreement.type === 'premium' || agreement.type === 'split') && <hr />}
        {(agreement.type === 'premium' || agreement.type === 'split') && (
          <div
            className={`ownership-work ${blockSelected && 'block-selected'}`}
          >
            {this.renderWorks()}

            <ul className="ownership-request">
              {ownershipBlocks.map(
                (block, i) =>
                  !finalized &&
                  this.getAcceptChangeStatus(block) && (
                    <li key={block.name}>
                      <span>{`${block.name}: `}</span>
                      {this.renderChangeRequests(block, 0)}
                    </li>
                  )
              )}
            </ul>
          </div>
        )}

        <Splits profile={profile} dealWork={dealWork} dealBlock={dealBlock} />
        {this.renderContractBlocks()}

        {(hasOtherRedline || hasOtherAcceptedRedline) && !finalized && (
          <RedlineRequestText other={true} />
        )}
        {this.renderFinalize()}
      </TermsSummary>
    );
  }

  renderPreviewWindow() {
    const { previewIndex, agreementPreviewMode } = this.state;
    const { deal, profile, dealChanges } = this.props;

    const isOwner = deal.user === profile.id;

    let previewIcon = previewIconLogic(isOwner);

    return (
      <div className="preview-window">
        <div className="preview-header">
          {previewIcon.map((item, index) => {
            if (index === 5) {
              // Download  button
              return (
                <div key={index} className="preview-item">
                  <Form
                    method="post"
                    ref="agreementToPDF"
                    onSubmit={this.handleAgreementDownload}
                  >
                    <input
                      type="hidden"
                      ref="agreementFilename"
                      name="agreement_filename"
                      value="agreement.pdf"
                    />
                    <input
                      type="hidden"
                      ref="agreementTextContents"
                      name="agreement_text"
                      value=""
                    />
                    <Button
                      bsStyle="link"
                      type="submit"
                      disabled={agreementPreviewMode !== 1}
                    >
                      <OverlayTrigger
                        overlay={
                          <Tooltip id="tooltip-split">{item[2]}</Tooltip>
                        }
                        placement="top"
                      >
                        <div>
                          <img src={item[1]} alt={index} />
                          <div className="echo-animation download-icon" />
                        </div>
                      </OverlayTrigger>
                    </Button>
                  </Form>
                </div>
              );
            } else {
              return (
                <div
                  key={index}
                  className={`preview-item ${
                    index === previewIndex && 'preview-item-selected'
                  }`}
                  onClick={(e) => this.handlePreviewItem(e, index)}
                >
                  <OverlayTrigger
                    overlay={<Tooltip id="tooltip-split">{item[2]}</Tooltip>}
                    placement="top"
                  >
                    <div>
                      <img
                        src={index === previewIndex ? item[0] : item[1]}
                        alt={index}
                      />
                      <div className="echo-animation" />
                    </div>
                  </OverlayTrigger>
                </div>
              );
            }
          })}
        </div>
        <div ref={(c) => (this.refPreview = c)} className="preview-body">
          {previewIndex === 0 && this.renderTermsSummary()}
          {previewIndex === 3 && deal && dealChanges && <DealChangeLog />}
          {previewIndex === 4 && deal && <DealMessage />}
        </div>

        <br />
      </div>
    );
  }

  collapsePreview = (e) => {
    e.preventDefault();
    this.setState((state) => ({
      isCollapsPreview: !state.isCollapsPreview,
    }));
  };

  changeAgreementPreviewMode = (val) => {
    this.setState({ agreementPreviewMode: val });
  };

  renderTabs(isOwner) {
    const { agreement, members, profile, invites } = this.props;
    const {
      blocks,
      tabs,
      dealWork,
      isCollapsPreview,
      finalized,
      agreementPreviewMode,
      showInviteModal,
      showInviteMemberModal,
    } = this.state;
    const isAttorney = getAttorneyStatus(profile, invites);

    let notFinalizedComponent = (
      <ButtonToolbar>
        <ToggleButtonGroup
          type="radio"
          name="options"
          defaultValue={1}
          value={agreementPreviewMode}
          onChange={this.changeAgreementPreviewMode}
        >
          <ToggleButton value={1}>View Current Proposed Draft</ToggleButton>
          <ToggleButton value={2}>View Testing Draft</ToggleButton>
        </ToggleButtonGroup>
      </ButtonToolbar>
    );

    let needMoreHelpTextLink = (
      <a
        href="https://cosynd.zendesk.com/hc/en-us/categories/115002431827-How-To-Guides"
        target="_blank"
      >
        Need more help? Click here to visit our knowledge base.
      </a>
    );

    if (blocks.length && members) {
      return (
        <div className="agreement-terms">
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.handleSelect(tabIndex)}
          >
            <TabList>
              {tabs.map((tab, i) => {
                const checked = this.getBlockChecked(tab.id);

                if (tab === '<' || tab === '>') {
                  return (
                    <Tab key={i} style={{ padding: '6px 12px' }}>
                      {tab}
                    </Tab>
                  );
                } else {
                  return (
                    <Tab key={i} style={{ width: this.tabWidth }}>
                      {tab.name}
                      {checked ? <FontAwesome name="check" /> : null}
                    </Tab>
                  );
                }
              })}
            </TabList>

            {tabs.map((tab, i) => {
              const blockIndex = this.getBlockIndex(tab);

              let overViewContractBlock = (
                <DealContractBlock
                  block={tab}
                  work={dealWork}
                  handleNext={() => this.handleTab('next')}
                  showNav={blocks.length > 1}
                  finalized={finalized}
                  isAttorney={isAttorney}
                />
              );

              let defaultContractBlock = (
                <DealContractBlock
                  block={tab}
                  work={dealWork}
                  {...this.getOptions(tab.id)}
                  finalized={finalized}
                  isAttorney={isAttorney}
                >
                  <div className="nav">
                    {blockIndex > 0 ? (
                      <button
                        onClick={(e) => this.handleTab('back')}
                        className="button-back"
                      >
                        Back
                      </button>
                    ) : null}
                    {blockIndex < blocks.length - 1 ? (
                      <button
                        onClick={(e) => this.handleTab('next')}
                        className="button-continue"
                      >
                        Continue
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          this.setState(
                            {
                              isCollapsPreview: false,
                              previewIndex: 0,
                            },
                            () => {
                              this.scrollToRef('DealStatus');
                            }
                          );
                        }}
                        className="button-continue"
                      >
                        Finish
                      </button>
                    )}
                  </div>
                </DealContractBlock>
              );

              if (tab === '<' || tab === '>') {
                return <TabPanel key={i} />;
              }

              return (
                <TabPanel key={i}>
                  <div>
                    <div className="tab-container">
                      <div className="content-panel">
                        {tab.name === 'Overview'
                          ? overViewContractBlock
                          : defaultContractBlock}
                        <br />
                        {needMoreHelpTextLink}
                        <br />
                      </div>
                      <ShowIcon
                        agreement={agreement}
                        isCollapse={isCollapsPreview}
                        collapsePreview={this.collapsePreview}
                      />
                      <div
                        className={`preview-panel ${
                          isCollapsPreview && 'preview-collapse-panel'
                        }`}
                      >
                        {this.renderPreviewWindow()}
                      </div>
                    </div>

                    <br />
                    <PreviewAgreementText />

                    {!finalized && notFinalizedComponent}
                    <div
                      className="preview-body"
                      ref={(c) => (this.refAgreementTextPreview = c)}
                    >
                      {this.renderAgreementText(isOwner)}
                    </div>
                  </div>
                </TabPanel>
              );
            })}
          </Tabs>
          <InviteOther
            show={showInviteModal}
            onClose={() => {
              this.setState({ showInviteModal: false });
            }}
          />
          <InviteMember
            show={showInviteMemberModal}
            onClose={() => {
              this.setState({ showInviteMemberModal: false });
            }}
          />
          <div className="pdf-wrapper">
            <div ref="printContainer" />
          </div>
        </div>
      );
    }
  }

  renderAgreementText(isOwner) {
    let { works, finalized, tabName, agreementPreviewMode } = this.state;
    if (this.props.agreement) {
      const agreementTextProps = {
        // type: 'deal-review',
        type: 'deal-edit',
        works: works,
        editable: !finalized && !this.props.agreement.completed,
        tabName: tabName ? tabName.replace(/\s/g, '') : '',
        isTestVersion: agreementPreviewMode === 2,
        isCurrentVersion: agreementPreviewMode === 1,
        isOwner: isOwner,
      };

      return (
        <div ref="agreementTerms" className="agreement-terms">
          {this.props.agreement.type === 'workforhire' ? (
            <AgreementTextWorkForHire
              ref={(c) => (this.refAgreementTextHire = c)}
              {...agreementTextProps}
            />
          ) : this.props.agreement.type === 'producer' ? (
            <AgreementTextProducer
              ref={(c) => (this.refAgreementTextProducer = c)}
              {...agreementTextProps}
            />
          ) : (
            <AgreementTextPremiumSplit
              ref={(c) => (this.refAgreementTextPremiumSplit = c)}
              {...agreementTextProps}
            />
          )}
        </div>
      );
    }
  }

  renderChangeRequests(block, type) {
    const {
      agreementContractBlocks,
      deal,
      dealUsers,
      dealChanges,
      members,
      invites,
      agreement,
    } = this.props;
    const { finalized } = this.state;

    let { changeRequests, accepts, changeRequests2, accepts2 } =
      getDealChangeRequests(
        block,
        dealChanges,
        members,
        deal,
        agreement,
        dealUsers
      );

    const { sentenceChanges, acceptedStatus } = getSentenceChanges(
      block.name.replace(/\s/g, ''),
      agreement,
      dealChanges,
      invites,
      dealUsers
    );

    // Make the changes to be accepted if it matched with owner's changes
    const currentBlockChange = _.find(
      agreementContractBlocks,
      (deal) => deal.contract_block === block.id
    );

    let newChangeRequests = changeRequestLogic(
      currentBlockChange,
      changeRequests,
      accepts,
      changeRequests2,
      accepts2,
      block
    );

    changeRequests = newChangeRequests.changeRequests;
    accepts = newChangeRequests.accepts;
    changeRequests2 = newChangeRequests.changeRequests2;
    accepts2 = newChangeRequests.accepts2;

    if (finalized) {
      if (acceptedStatus) {
        return (
          <div className="answer">
            <RedlineRequestText />
          </div>
        );
      }

      return null;
    }

    return (
      <div className="answer">
        {(sentenceChanges.length > 0 || acceptedStatus) && (
          <RedlineRequestText />
        )}
        {(type === 0 || type === 1) && (
          <div>
            <Accepts accepts={accepts} />
            <Changes changeRequests={changeRequests} />
            {(accepts2 && accepts2.length) ||
            (changeRequests2 && changeRequests2.length) ? (
              <hr />
            ) : null}
          </div>
        )}
        {(type === 0 || type === 2) && (
          <div>
            <Accepts accepts={accepts2} />
            <Changes changeRequests={changeRequests2} />
          </div>
        )}
      </div>
    );
  }

  render() {
    const { router, profile, agreement, invites } = this.props;
    const { dealOwner, blocks } = this.state;

    let isOwner = false;
    if (dealOwner) {
      isOwner = profile.id === dealOwner.user;
    }

    const isAttorney = getAttorneyStatus(profile, invites);

    return (
      <div
        className={`dealroom-content ${
          agreement && agreement.archived && 'disabled'
        }`}
      >
        {blocks.length > 0 &&
          (isOwner ? (
            <OwnerTextIntro />
          ) : isAttorney ? (
            <AttorneyTextIntro />
          ) : (
            <CollaboratorTextIntro />
          ))}
        <br />

        <div ref="tabsContainer" className="content">
          {this.renderTabs(isOwner)}
        </div>
        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => router.push(`/agreements`)}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  ownershipTypes: state.global.ownershipTypes,
  contractBlocks: state.global.contractBlocks,
  workTypes: state.global.workTypes,
  agreementContractBlocks: state.agreements.contractBlocks,
  agreement: state.agreements.selectedAgreement,
  deal: state.deals.selectedDeal,
  dealChanges: state.deals.dealChanges,
  dealUsers: state.dealUsers.dealUsers,
  invites: state.invites.invites,
  members: state.users.members,
  dealBlocks: state.dealBlocks.dealBlocks,
  statusDealUsers: state.dealUsers.status,
  statusUsers: state.users.status,
  subWorkTypes: state.global.subWorkTypes,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  setDealBlockChanges: (changes) => {
    dispatch(actions.setDealBlockChanges(changes));
  },
  resetDealBlockChanges: () => {
    dispatch(actions.resetDealBlockChanges());
  },
  updateAgreement: (agreement) => {
    dispatch(actions.updateAgreement(agreement.id, agreement));
  },
  updateDeal: (dealId, deal) => {
    dispatch(actions.updateDeal(dealId, deal));
  },
  createDealChange: (dealChange) => {
    dispatch(actions.createDealChange(dealChange));
  },
  saveBlockContent: (block) => {
    dispatch(actions.saveAgreementContractBlockContent(block));
  },
  updateWork: (workId, work) => {
    dispatch(actions.updateWork(workId, work));
  },
  updateWorkOwnership: (ownership) => {
    dispatch(actions.updateWorkOwnership(ownership));
  },
  createPublisher: (publisher) => {
    dispatch(actions.createPublisher(publisher));
  },
  deletePublisher: (publisher) => {
    dispatch(actions.deletePublisher(publisher));
  },
  updatePublisher: (publisher) => {
    dispatch(actions.updatePublisher(publisher));
  },
  notifyDealChange: (dealChange) => {
    dispatch(actions.notifyDealChange(dealChange));
  },
  updateDealChange: (dealChange) => {
    dispatch(actions.updateDealChange(dealChange));
  },
  updateDealUser: (dealUser) => {
    dispatch(actions.updateDealUser(dealUser));
  },
  loadDealInvites: (dealId) => {
    dispatch(actions.getInvites(dealId));
  },
  loadDealChanges: (dealId) => {
    dispatch(actions.getDealChanges(dealId));
  },
  sendEmailToInviteeDealChange: (data) => {
    dispatch(actions.sendEmailToInviteeDealChange(data));
  },
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DealEdit);



// WEBPACK FOOTER //
// src/components/Deals/DealEdit.jsx